var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICN_-Error",
    "data-name": "ICN -Error",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "error_FILL0_wght400_GRAD0_opsz48",
    d: "M20,36a15.481,15.481,0,0,1-6.2-1.26A16.12,16.12,0,0,1,5.26,26.2a15.982,15.982,0,0,1,0-12.44A15.99,15.99,0,0,1,8.7,8.68a16.4,16.4,0,0,1,5.1-3.42,15.982,15.982,0,0,1,12.44,0,15.975,15.975,0,0,1,8.5,8.5,15.982,15.982,0,0,1,0,12.44,16.4,16.4,0,0,1-3.42,5.1,15.99,15.99,0,0,1-5.08,3.44A15.58,15.58,0,0,1,20,36Z",
    transform: "translate(-4 -4)",
    fill: "#e81123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "error_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "error_FILL0_wght400_GRAD0_opsz48",
    d: "M20,28a1.3,1.3,0,1,0-.94-.38A1.277,1.277,0,0,0,20,28Zm-1.08-6.12h2.4V11.76h-2.4ZM20,20Z",
    transform: "translate(-3.68 -4)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.c2d3229d85419648fd501f81ee26ad00.svg";
export { ForwardRef as ReactComponent };